"use client";

import { usePathname } from "next/navigation";
import Navbar from "@/components/ui/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import { SpeedInsights } from "@vercel/speed-insights/next";

export default function MarketingWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const isPortal = pathname?.startsWith("/portal") || pathname?.startsWith("/studio");

  if (isPortal) {
    return <>{children}</>;
  }

  // The marker scopes the marketing typography in globals.css to public pages.
  return (
    <div data-site-surface="marketing" className="contents">
      <div className="pointer-events-none fixed inset-0 -z-10 bg-[url('/grid-block.png')] bg-[length:36px_36px] bg-repeat opacity-50" />
      <div className="fixed top-0 left-1/2 z-50 w-full -translate-x-1/2 md:top-4 md:px-6">
        <Navbar />
      </div>
      {children}
      <Footer />
      <SpeedInsights />
      <CookieBanner />
    </div>
  );
}
